import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  banner_url: '',
  title_vi: '',
  title_en: '',
  title_jp: '',
  date: '',
  author: '',
  description_vi: '',
  description_en: '',
  description_jp: '',
  content_vi: '',
  content_en: '',
  content_jp: '',
  main_post: '',
  popular_new: '',
  topic: '',
  search: '',
  status: '',
};
export const newsItemSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {
    setItem: (state, action) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
    setDefaultValue: (_, action) => {
      if (!action?.payload?.id) return initialState;
      return { ...action.payload };
    },
    resetData: () => {
      return initialState;
    },
  },
});
export const { setItem, setDefaultValue, resetData } = newsItemSlice.actions;

export default newsItemSlice.reducer;
